/**
 * Vault image metadata for the preview modal session (independent of unmaskedCards cache).
 */

export const getVaultUrlForIndexFromData = (vaultImageUrl, vaultImages, index) => {
  if (Array.isArray(vaultImages) && vaultImages.length > 0) {
    return vaultImages.find(img => img.index === index + 1)?.url ?? null
  }
  return index === 0 ? vaultImageUrl : null
}

export const buildVaultPreviewPayloadFromUnmasked = (unmaskedCards, cardId) => {
  if (!cardId || !unmaskedCards?.[cardId]) {
    return {
      isVaultSource: false,
      vaultImageUrl: null,
      vaultImages: null
    }
  }

  const data = unmaskedCards[cardId]
  const vaultImageUrl = data.imageUrl || null
  const vaultImages =
    data.images || (vaultImageUrl ? [{ url: vaultImageUrl, index: 1 }] : null)
  const hasVault =
    !!vaultImageUrl || (Array.isArray(vaultImages) && vaultImages.length > 0)

  return {
    isVaultSource: hasVault,
    vaultImageUrl,
    vaultImages
  }
}

export const getVaultUrlForPreviewSession = (imagePreview, index) => {
  if (!imagePreview?.isVaultSource) return null
  return getVaultUrlForIndexFromData(
    imagePreview.vaultImageUrl,
    imagePreview.vaultImages,
    index
  )
}
